// Auto-extracted tab: policies
import React, { useState, useEffect, useMemo, useCallback } from 'react';

/**
 * PoliciesTab - extracted from app.jsx
 * Original lines: 9230-9352
 * 
 * TODO: This component needs props passed from AppContent:
 * - darkMode, scenarios, thresholds, etc.
 * - All the state and handlers it uses
 */
export function PoliciesTab(props) {
  // Original render content (needs refactoring to use props):
  return (
    <>
          <div className="space-y-6">
            {/* Summary Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div className={`p-4 rounded-xl ${darkMode ? "bg-slate-800/50 border border-slate-700" : "bg-white border border-slate-200"}`}>
                <div className={`text-2xl font-bold ${darkMode ? "text-white" : "text-slate-900"}`}>{policies.length}</div>
                <div className={`text-sm ${darkMode ? "text-slate-500" : "text-slate-600"}`}>Total Policies</div>
              </div>
              <div className={`p-4 rounded-xl ${darkMode ? "bg-emerald-900/30 border border-emerald-800" : "bg-emerald-50 border border-emerald-200"}`}>
                <div className={`text-2xl font-bold ${darkMode ? "text-emerald-400" : "text-emerald-700"}`}>
                  {policies.filter(p => p.status === 'published').length}
                </div>
                <div className={`text-sm ${darkMode ? "text-emerald-300" : "text-emerald-600"}`}>Published</div>
              </div>
              <div className={`p-4 rounded-xl ${darkMode ? "bg-amber-900/30 border border-amber-800" : "bg-amber-50 border border-amber-200"}`}>
                <div className={`text-2xl font-bold ${darkMode ? "text-amber-400" : "text-amber-700"}`}>
                  {policies.filter(p => p.status === 'pending_review' || p.status === 'pending_approval').length}
                </div>
                <div className={`text-sm ${darkMode ? "text-amber-300" : "text-amber-600"}`}>Pending Review</div>
              </div>
              <div className={`p-4 rounded-xl ${darkMode ? "bg-red-900/30 border border-red-800" : "bg-red-50 border border-red-200"}`}>
                <div className={`text-2xl font-bold ${darkMode ? "text-red-400" : "text-red-700"}`}>
                  {policies.filter(p => p.review_date && new Date(p.review_date) < new Date()).length}
                </div>
                <div className={`text-sm ${darkMode ? "text-red-300" : "text-red-600"}`}>Overdue Review</div>
              </div>
            </div>
            
            {/* Policy List */}
            <Card 
              darkMode={darkMode} 
              title="Policy Library" 
              subtitle="Policies, procedures, standards, and guidelines"
              actions={
                <div className="flex gap-2">
                  <Button variant="ghost" size="sm" onClick={loadPolicyData} disabled={policyLoading}>
                    <Icons.Refresh className={policyLoading ? "animate-spin" : ""} />
                  </Button>
                  <Button variant="primary" size="sm" onClick={() => setPolicyModal({ open: true, policy: null })}>
                    <Icons.Plus /> Add Policy
                  </Button>
                </div>
              }
            >
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead className={darkMode ? "bg-slate-800/50" : "bg-gradient-to-r from-slate-50 to-slate-100/80"}>
                    <tr>
                      <th className={`text-left py-3.5 px-4 font-semibold ${darkMode ? "text-slate-300" : "text-slate-700"}`}>Number</th>
                      <th className={`text-left py-3.5 px-4 font-semibold ${darkMode ? "text-slate-300" : "text-slate-700"}`}>Title</th>
                      <th className={`text-left py-3 px-2 font-medium ${darkMode ? "text-slate-500" : "text-slate-600"}`}>Type</th>
                      <th className={`text-left py-3 px-2 font-medium ${darkMode ? "text-slate-500" : "text-slate-600"}`}>Category</th>
                      <th className={`text-left py-3 px-2 font-medium ${darkMode ? "text-slate-500" : "text-slate-600"}`}>Status</th>
                      <th className={`text-left py-3 px-2 font-medium ${darkMode ? "text-slate-500" : "text-slate-600"}`}>Review Date</th>
                      <th className={`text-left py-3 px-2 font-medium ${darkMode ? "text-slate-500" : "text-slate-600"}`}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {policies.map(policy => (
                      <tr key={policy.id} className={`${darkMode ? "border-slate-700/50 hover:bg-slate-800/50" : "border-slate-100 hover:bg-slate-50"} border-b`}>
                        <td className={`py-3 px-2 font-mono ${darkMode ? "text-blue-400" : "text-blue-600"}`}>{policy.policy_number}</td>
                        <td className={`py-3 px-2 font-medium ${darkMode ? "text-white" : "text-slate-900"}`}>{policy.title}</td>
                        <td className={`py-3 px-2 ${darkMode ? "text-slate-300" : "text-slate-700"}`}>{policy.policy_type}</td>
                        <td className={`py-3 px-2 ${darkMode ? "text-slate-300" : "text-slate-700"}`}>{policy.category}</td>
                        <td className="py-3 px-2">
                          <Badge variant={
                            policy.status === 'published' ? 'success' :
                            policy.status === 'approved' ? 'success' :
                            policy.status === 'pending_approval' ? 'high' :
                            policy.status === 'pending_review' ? 'medium' :
                            'default'
                          }>
                            {policy.status?.replace('_', ' ')}
                          </Badge>
                        </td>
                        <td className={`py-3 px-2 ${
                          policy.review_date && new Date(policy.review_date) < new Date() 
                            ? (darkMode ? "text-red-400" : "text-red-600") 
                            : (darkMode ? "text-slate-300" : "text-slate-700")
                        }`}>
                          {policy.review_date ? new Date(policy.review_date).toLocaleDateString() : '-'}
                        </td>
                        <td className="py-3 px-2">
                          <div className="flex gap-1">
                            <Button variant="ghost" size="xs" onClick={() => setPolicyDetailModal({ open: true, policy })}>
                              <Icons.Eye />
                            </Button>
                            <Button variant="ghost" size="xs" onClick={() => openPolicyEdit(policy)}>
                              <Icons.Edit />
                            </Button>
                            <Button variant="ghost" size="xs" onClick={() => openDeleteModal("policy", policy)}>
                              <Icons.Trash className="w-4 h-4 text-red-500" />
                            </Button>
                          </div>
                        </td>
                      </tr>
                    ))}
                    {policies.length === 0 && (
                      <tr>
                        <td colSpan={7} className="p-4">
                          <EducationalEmptyState
                            title="No policies documented yet"
                            examinerSays="Where's your BSA/AML policy? When was it last approved by the board? Show me your policy review schedule and approval documentation."
                            example="BSA/AML Policy - Board-approved comprehensive policy covering CIP, CDD, SAR filing, CTR requirements. Annual review with documented board approval on 2024-03-15."
                            templates={[
                              { name: "BSA/AML Policy", type: "bsa_aml" },
                              { name: "Customer Identification Program", type: "cip" },
                              { name: "Suspicious Activity Reporting", type: "sar_policy" },
                              { name: "OFAC Compliance Policy", type: "ofac" },
                            ]}
                            onAddBlank={() => setPolicyModal({ open: true, policy: null })}
                            onSelectTemplate={(t) => setPolicyModal({ open: true, policy: null, template: t.type })}
                            darkMode={darkMode}
                          />
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </Card>
          </div>
    </>
  );
}

export default PoliciesTab;
